import React,{
createContext,
useContext,
useState,
useEffect
} from 'react';

import api from "../services/api";

const InventoryContext = createContext();

export const useInventory = () => useContext(InventoryContext);

const formatDate = (date) => {

  if (!date) return "";

  const d = new Date(date);

  const year = d.getFullYear();

  const month = String(
    d.getMonth() + 1
  ).padStart(2, "0");

  const day = String(
    d.getDate()
  ).padStart(2, "0");

  return `${year}-${month}-${day}`;

};

export const InventoryProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [devices, setDevices] = useState([]);
  const [sims, setSims] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [subCompanies, setSubCompanies] = useState([]);

 const getAllowedCompanyIds = (user) => {

 if(
  !user ||
  user.role === "super_admin"
 ){

  return null;

 }

 const company =
  companies.find(
   c =>
   String(c.id) ===
   String(user.companyId)
  );

 if(!company){

  return [user.companyId];

 }

 const subIds =
 subCompanies
 .filter(
  s =>
  s.parentCompanyName ===
  company.name
 )
 .map(
  s => s.id
 );

 return [

  user.companyId,

  ...subIds

 ];

};

 const getToday = () => {

  const today = new Date();

  const year = today.getFullYear();

  const month = String(
    today.getMonth() + 1
  ).padStart(2, '0');

  const day = String(
    today.getDate()
  ).padStart(2, '0');

  return `${year}-${month}-${day}`;

};

 useEffect(()=>{

loadCompanies();

loadSubCompanies();
 loadDevices();
  loadSims();
 loadVehicles();
  const interval = setInterval(() => {
    loadVehicles();
  }, 3000);

  return () => clearInterval(interval);
},[]);

const loadCompanies=
async()=>{

try{

const response=
await api.get(
"/company"
);

const formatted=

response.data.data.map(
company=>({

...company,

contactPerson:
company.contact_person

})
);

setCompanies(
formatted
);

}
catch(error){

console.log(
"Load Company Error",
error
);}
};

const addCompany=
async(company)=>{

try{

const payload={

name:
company.name,

address:
company.address,

contact_person:
company.contactPerson,

phone:
company.phone

};

await api.post(

"/company",
payload

);

await loadCompanies();

}
catch(error){

console.log(error);

}

};

const updateCompany=
async(id,updated)=>{

try{

const payload={

name:
updated.name,

address:
updated.address,

contact_person:
updated.contactPerson,

phone:
updated.phone

};

await api.put(

`/company/${id}`,

payload

);

await loadCompanies();

}
catch(error){

console.log(error);

}

};
const deleteCompany = async(id)=>{

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this company and all related data?"
  );

  if(!confirmDelete) return;

  try{

    await api.delete(`/company/${id}`);
    await loadCompanies();

  }catch(error){

    console.log(error);
    alert("Delete failed");

  }
};

const loadSubCompanies = async () => {

 try {

  const response = await api.get("/subcompany");
  const subCompanyData =
   response.data.data ||
   response.data ||
   [];

 const formatted =
 subCompanyData.map(item => ({

  ...item,

  parentCompanyId:
   item.parent_company_id || "",

  parentCompanyName:
   item.parent_company_name || "",

  contactPerson:
   item.contact_person || ""

 }));

  setSubCompanies(formatted);

 }
 catch(error){

  console.log(
   "Load SubCompany Error",
   error
  );

 }

};

const addSubCompany =
async(sub)=>{

 try{

  const company =
   companies.find(
    c =>
    String(c.id) ===
    String(sub.parentCompanyId)
   );

  if(!company){

   return;

  }

  const payload = {

   parent_company_id:
    company.id,

   parent_company_name:
    company.name,

   name:
    sub.name,

   address:
    sub.address,

   contact_person:
    sub.contactPerson,

   phone:
    sub.phone

  };

  await api.post(
   "/subcompany",
   payload
  );

  await loadSubCompanies();

 }
 catch(error){

  console.log(
   "Add SubCompany Error",
   error
  );

 }

};

const updateSubCompany =
async(id,updated)=>{

 try{

  const company =
   companies.find(
    c =>
    String(c.id) ===
    String(updated.parentCompanyId)
   );

  if(!company){

   return;

  }

  const payload = {

   parent_company_id:
    company.id,

   parent_company_name:
    company.name,

   name:
    updated.name,

   address:
    updated.address,

   contact_person:
    updated.contactPerson,

   phone:
    updated.phone

  };

  await api.put(
   `/subcompany/${id}`,
   payload
  );

  await loadSubCompanies();

 }
 catch(error){

  console.log(
   "Update SubCompany Error",
   error
  );

 }

};

const deleteSubCompany =
async(id)=>{

 try{

  await api.delete(
   `/subcompany/${id}`
  );

  await loadSubCompanies();

 }
 catch(error){

  console.log(
   "Delete SubCompany Error",
   error
  );

 }

};

const getSubCompaniesByCompany =
(companyId)=>{

 const company =
  companies.find(
   c =>
   String(c.id) ===
   String(companyId)
  );

 if(!company){

  return [];

 }

 return subCompanies.filter(
  s =>
  s.parentCompanyName ===
  company.name
 );

};

const getEntityDisplayName = (companyId) => {

  if (!companyId) return "-";

  const subCompany = subCompanies.find(
    sub => String(sub.id) === String(companyId)
  );

  if (subCompany) {

    const parentCompany = companies.find(
      company =>
        String(company.id) ===
        String(subCompany.parentCompanyId)
    );

    return parentCompany
      ? `${parentCompany.name} (${subCompany.name})`
      : subCompany.name;
  }

  const company = companies.find(
    company =>
      String(company.id) === String(companyId)
  );

  if (company) {
    return company.name;
  }


  return "-";
};

const loadDevices = async () => {
 try{
  const response =
  await api.get("/device");
 

 const formatted =
response.data.map(device => ({

  ...device,

  slNumber:
  device.serial_number || "",

  purchaseDate:
  formatDate(device.purchase_date),

  warrantyEnd:
  formatDate(device.warranty_end),

  installationDate:
  formatDate(device.installation_date),

    installationWarrantyEnd:
  formatDate(
    device.installation_warranty_end
  ),

  companyId:
  device.company_id || ""

}));

  setDevices(formatted);

 }
 catch(error){

  console.log(
   "Load Device Error",
   error
  );

 }

};

const addDevice = async (device) => {

  try {

    const warrantyDate =
      device.purchaseDate
        ? calculateWarranty(device.purchaseDate)
        : null;

    await api.post("/device", {
      imei: device.imei,
      serial_number: device.slNumber,
      model: device.model,
      make: device.make,
      purchase_date: device.purchaseDate,
      warranty_end: warrantyDate,
      status: device.status,
      parent_company_id: device.parentCompanyId,
      company_id: device.companyId,
      installation_date: device.installationDate || null
    });

    await loadDevices();

  } catch (error) {

    console.log(
      "Add Device Error",
      error.response?.data || error
    );

  }

};

const updateDevice = async (id, updated) => {

  try {

    await api.put(`/device/${id}`, {
      imei: updated.imei,
      serial_number: updated.slNumber || "",
      model: updated.model || "",
      make: updated.make || "",
      purchase_date: updated.purchaseDate || "",
      warranty_end:
        updated.purchaseDate
          ? calculateWarranty(updated.purchaseDate)
          : updated.warrantyEnd,
      status: updated.status || "",
      parent_company_id:
        updated.parentCompanyId || "",
      company_id:
        updated.companyId || "",
      installation_date:
        updated.installationDate || ""
    });

    await loadDevices();

  } catch (error) {

    console.log(
      "Update Device Error",
      error.response?.data || error
    );

  }

};
const deleteDevice = async(id)=>{

 try{

  await api.delete(

   `/device/${id}`

  );

  await loadDevices();

 }
 catch(error){

  console.log(
   "Delete Device Error",
   error
  );

 }

};

const loadSims = async () => {

 try{

  const response =
  await api.get("/sim");

const formatted =
response.data.map(sim => ({

  ...sim,

  mobileNo: sim.mobile_no || "",

  simNo: sim.sim_no || "",

  purchaseDate:
  formatDate(sim.purchase_date),

  safecustodyDate:
  formatDate(sim.safecustody_date),

  installationDate:
  formatDate(sim.installation_date),

   installationWarrantyEnd:
    formatDate(
      sim.installation_warranty_end
    ),

  companyId:
  sim.company_id || "",

  parentCompanyId:
  sim.parent_company_id || ""

}));

  setSims(formatted);

 }
 catch(error){

  console.log(
   "Load SIM Error",
   error
  );

 }

};


const addSim = async(sim)=>{

 try{



  await api.post("/sim", {
    mobile_no: sim.mobileNo,
    sim_no: sim.simNo,
    vendor: sim.vendor,
    purchase_date: sim.purchaseDate,
    status: sim.status,
    safecustody_date: sim.safecustodyDate,
    installation_date: sim.installationDate || null,
    parent_company_id: sim.parentCompanyId || null,
    company_id: sim.companyId || null
  });

  await loadSims();

 } catch(error){
   console.log(error);
 }

};
const updateSim = async (id, updated) => {
  try {

    await api.put(`/sim/${id}`, {
      mobile_no: updated.mobileNo,
      sim_no: updated.simNo,
      vendor: updated.vendor,
      purchase_date: updated.purchaseDate || null,
      status: updated.status,
      safecustody_date: updated.safecustodyDate || null,
      installation_date: updated.installationDate || null,
      parent_company_id: updated.parentCompanyId || null,
      company_id: updated.companyId || null
    });

    await loadSims();

  } catch (error) {

    console.log("Update SIM Error", error);

  }
};

const deleteSim = async(id)=>{
 try{
  await api.delete(
   `/sim/${id}`
  );

  await loadSims();

 }
 catch(error){

  console.log(

   "Delete SIM Error",

   error

  );

 }

};

  const checkSimStatuses = () => {
    const today = new Date();
    setSims(prev => prev.map(sim => {
      if (sim.status === 'safecustody' && sim.safecustodyDate) {
        const scDate = new Date(sim.safecustodyDate);
        const diffDays = (today - scDate) / (1000 * 60 * 60 * 24);
        if (diffDays >= 90) {
          return { ...sim, status: 'scrap' };
        }
      }
      return sim;
    }));
  };

//   const loadVehicles = async () => {
//   try {
//     const response =await api.get("/vehicle");
// console.log("VEHICLES API:", response.data);
//   const formatted = response.data.map(vehicle => {
//   const finalCompany =
//     vehicle.sub_company_id || vehicle.company_id || "";

//   const images = vehicle.images
//     ? vehicle.images.replace(/[{}]/g, "").split(",")
//     : [];

//   const imageUrls = images.map(img =>
//     `https://cccs.cordonnx.com${img}`
//   );

//   return {
//     ...vehicle,

//     licensePlate: vehicle.vehicle_number || "",

//     company: String(finalCompany),

//     parentCompanyId: String(vehicle.company_id || ""),

//     subCompanyId: String(vehicle.sub_company_id || ""),

//     imei: String(vehicle.device_id || ""),

//     sim: String(vehicle.sim_id || ""),

//     vehicleType: vehicle.vehicle_type || "bike",

//   panic_buttons: vehicle.panic_buttons || 0,

//    accessories: vehicle.accessories || [],

//     images: (vehicle.images || []).map(img => 
//       `https://cccs.cordonnx.com${img}` ),

//     installedBy: vehicle.installed_by || "",

//     ignition: vehicle.ignition ?? false,
//     sos: vehicle.sos ?? false,
//     latitude: vehicle.latitude,
//     longitude: vehicle.longitude,
//     gpsLastUpdate: vehicle.gps_time,
//   };

// });

//     setVehicles(formatted);

//   }
//   catch(error){

//     console.log(
//       "Load Vehicle Error",
//       error
//     );

//   }

// };

const loadVehicles = async () => {
  try {
    const response = await api.get("/vehicle");    
    const formatted = response.data.map(vehicle => {
      const finalCompany = vehicle.sub_company_id || vehicle.company_id || "";

      // FIX: Properly handle images - works for both array and string formats
      let images = [];
      if (vehicle.images) {
        if (Array.isArray(vehicle.images)) {
          images = vehicle.images;
        } else if (typeof vehicle.images === 'string') {
          // Handle string format like "{/uploads/...png,/uploads/...png}"
          const cleaned = vehicle.images.replace(/[{}]/g, "");
          images = cleaned ? cleaned.split(",").filter(Boolean) : [];
        }
      }

      // Build full image URLs
      const imageUrls = images.map(img => {
        if (img.startsWith('https://')) return img;
        if (img.startsWith('/')) return `https://cccs.cordonnx.com${img}`;
        return `https://cccs.cordonnx.com/${img}`;
      });

      return {
        ...vehicle,
        licensePlate: vehicle.vehicle_number || "",
        company: String(finalCompany),
        parentCompanyId: String(vehicle.company_id || ""),
        subCompanyId: String(vehicle.sub_company_id || ""),
        imei: String(vehicle.device_id || ""),
        sim: String(vehicle.sim_id || ""),
        vehicleType: vehicle.vehicle_type || "bike",
        panic_buttons: vehicle.panic_buttons || 0,
        accessories: vehicle.accessories || [],
        images: imageUrls,
        installedBy: vehicle.installed_by || "",
        ignition: vehicle.ignition ?? false,
        sos: vehicle.sos ?? false,
        latitude: vehicle.latitude,
        longitude: vehicle.longitude,
        gpsLastUpdate: vehicle.gps_time,
         category: vehicle.category || ''
      };
    });

    setVehicles(formatted);

  } catch (error) {
    console.log("Load Vehicle Error", error);
  }
};

const addVehicle = async (vehicle) => {
  try {
    console.log('📤 ADD VEHICLE - Data received:', vehicle);
    console.log('📸 Images count:', vehicle.images?.length || 0);

    // Determine company and sub-company IDs
    let companyId = vehicle.company || vehicle.company_id || null;
    let subCompanyId = vehicle.sub_company_id || null;

    // If a sub-company is selected, find its parent
    if (vehicle.company && !vehicle.sub_company_id) {
      const selectedSubCompany = subCompanies.find(
        s => String(s.id) === String(vehicle.company)
      );
      
      if (selectedSubCompany) {
        companyId = selectedSubCompany.parentCompanyId;
        subCompanyId = selectedSubCompany.id;
      } else {
        companyId = vehicle.company;
        subCompanyId = null;
      }
    }

    // Validate required fields
    if (!companyId) {
      throw new Error("Company ID is required. Please select a company.");
    }

    const vehicleNumber = vehicle.licensePlate || vehicle.vehicle_number || "";
    if (!vehicleNumber) {
      throw new Error("Vehicle number is required.");
    }

    // ✅ FIX: Send as JSON, NOT FormData
    const payload = {
      vehicle_number: vehicleNumber,
      company_id: companyId,
      sub_company_id: subCompanyId || "",
      device_id: vehicle.imei || vehicle.device_id || "",
      sim_id: vehicle.sim || vehicle.sim_id || "",
      panic_buttons: vehicle.panic_buttons || vehicle.panicButtons || 0,
      installation_date: getToday(),
      vehicle_type: vehicle.vehicleType || vehicle.vehicle_type || "bike",
      status: vehicle.status || "active",
      installer_id: vehicle.installer_id || vehicle.installerId || "",
      accessories: JSON.stringify(vehicle.accessories || []),
      category: vehicle.category || '',
      images: vehicle.images || []  // ← This is the array of base64 strings
    };

    console.log('📤 Sending payload:', payload);
    console.log('📸 Images in payload:', payload.images?.length || 0);

    // Make the API call with JSON
    const response = await api.post("/vehicle", payload, {
      headers: {
        "Content-Type": "application/json"  // ← This is critical!
      }
    });

    console.log('✅ Vehicle created:', response.data);

    // Reload data
    await loadVehicles();
    await loadDevices();
    await loadSims();

    // Return the created vehicle data with its ID
    return response.data.data || response.data;

  } catch (error) {
    console.error("=== ADD VEHICLE ERROR ===");
    console.error("Error:", error);
    console.error("Error response:", error.response?.data);
    throw error;
  }
};


const updateVehicle = async (id, updated) => {
  try {
    console.log('📤 UPDATE VEHICLE - Data received:', updated);
    console.log('📸 Images count:', updated.images?.length || 0);

    const selectedSubCompany = subCompanies.find(
      s => String(s.id) === String(updated.company)
    );

    let companyId = updated.company;
    let subCompanyId = null;

    if (selectedSubCompany) {
      companyId = selectedSubCompany.parentCompanyId;
      subCompanyId = selectedSubCompany.id;
    }

    // ✅ FIX: Send as JSON, NOT FormData
    const payload = {
      vehicle_number: updated.licensePlate || "",
      company_id: companyId || "",
      sub_company_id: subCompanyId || "",
      device_id: updated.imei || "",
      sim_id: updated.sim || "",
      panic_buttons: updated.panic_buttons || updated.panicButtons || 0,
      installation_date: getToday(),
      vehicle_type: updated.vehicleType || updated.vehicle_type || "bike",
      status: "active",
      installer_id: updated.installer_id || updated.installerId || "",
      accessories: JSON.stringify(updated.accessories || []),
      category: updated.category || '',
      images: updated.images || []  // ← This is the array of base64 strings
    };

    console.log('📤 Update payload:', payload);
    console.log('📸 Images in update:', payload.images?.length || 0);

    const response = await api.put(`/vehicle/${id}`, payload, {
      headers: {
        "Content-Type": "application/json"  // ← This is critical!
      }
    });

    console.log('✅ Vehicle updated:', response.data);

    await loadVehicles();
    await loadDevices();
    await loadSims();

    return response.data;

  } catch (error) {
    console.log("❌ Update Vehicle Error:", error);
    console.log("Error response:", error.response?.data);
    throw error;
  }
};

const deleteVehicle = async (id) => {
  try {
    await api.delete(`/vehicle/${id}`);
    await loadVehicles();
    await loadDevices();
    await loadSims();
  } catch (error) {
    console.log("Delete Vehicle Error", error);
  }
};

 const getVehicleCountByCompany = (companyId) => {

  return vehicles.filter(v => {

    // DIRECT COMPANY VEHICLE
    if (
      String(v.company) === String(companyId)
    ) {
      return true;
    }

    // CHECK SUB COMPANY
    const subCompany = subCompanies.find(
      s =>
        String(s.id) ===
        String(v.company)
    );

    // IF VEHICLE BELONGS TO SUB COMPANY
    // AND THAT SUB COMPANY BELONGS TO MAIN COMPANY
    if (
      subCompany &&
      String(subCompany.parentCompanyId) ===
      String(companyId)
    ) {
      return true;
    }

    return false;

  }).length;

};

const calculateWarranty = (purchaseDate) => {

  if (!purchaseDate) return '';

  const d = new Date(purchaseDate);

  d.setFullYear(
    d.getFullYear() + 1
  );

  const year = d.getFullYear();

  const month = String(
    d.getMonth() + 1
  ).padStart(2, '0');

  const day = String(
    d.getDate()
  ).padStart(2, '0');

  return `${year}-${month}-${day}`;

};

  return (
    <InventoryContext.Provider value={{
      companies, addCompany, updateCompany, deleteCompany,
      devices, addDevice, updateDevice, deleteDevice,
      sims, addSim, updateSim, deleteSim, checkSimStatuses,
      vehicles, addVehicle, updateVehicle, deleteVehicle,
      getVehicleCountByCompany,subCompanies, addSubCompany, 
      updateSubCompany, deleteSubCompany,  getSubCompaniesByCompany,
    getAllowedCompanyIds,
    getEntityDisplayName,loadVehicles 
    }}>
      {children}
    </InventoryContext.Provider>
  );
};